import React, { Fragment } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";

import { Grid, InputAdornment, Button, MenuItem } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

import InputFormat from "../../../../partials/inputForm";
import { getNumberOnString } from "../../../../partials/validateNumber";
import Snackbar from "../../../snackbar";
import SelectMenu from "../selectMenu";
import NumberFormatCustom from "../../../numberFormat";
import DescriptionComponent from "../../../descriptionComponent";
import { styles } from "../styles";
class AddMenuItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        title: "",
        price: "",
        priceShow: "",
        description: "",
        itemTime: "",
        position: 0,
        menuId: "",
        showOnShop: 1,
        isShowPrice: 1,
      },
      open: false,
      notify: "",
      flagOpen: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.addMenuItem = this.addMenuItem.bind(this);

    this.reset = this.reset.bind(this);
  }
  async componentDidMount() {
    this.props.onRef(this);
    this.setState({ serviceSetting: this.props.serviceSetting });
  }
  async addMenuItem() {
    const { serviceSetting, t } = this.props;
    var data = {
      code: `${serviceSetting.prefixItem}${serviceSetting.totalItem + 1}`,
      ...this.state.data,
      position: this.state.data.position || this.props.positionState + 1,
      menuId: this.selectMenu.getData(),
    };
    let check = await this.props.serviceMenuItemDispatch.addMenuItem(data);
    if (check && check.code == 1) {
      this.props.finishAction(check.code, "add");
      if (this.props.handleCancel) this.props.handleCancel();
    } else {
      this.mSnackbar.handleClick(check.message, "error");
    }
  }
  reset() {
    this.setState({
      data: {
        title: "",
        price: "",
        priceShow: "",
        description: "",
        itemTime: "",
        position: 0,
      },
    });
    this.selectMenu.reset();
    this.DescriptionComponent.reset();
  }
  handleChange = (event) => {
    var data = this.state.data;
    let name = event.target.name;
    let value = event.target.value;
    if (name === "priceShow" || name === "price" || name === "itemTime")
      value = getNumberOnString(value);
    data[name] = value;
    this.setState({ data });
  };
  handleSubmit = () => {
    var { t } = this.props;
    var data = {
      ...this.state.data,
      menuId: this.selectMenu.getData(),
      priceShow: this.state.data.priceShow,
    };
    if (!data.menuId) {
      this.mSnackbar.handleClick(
        t("menu_menuitem_addmenuitem_please_select_menu_group"),
        "warning"
      );
    } else if (!data.title) {
      this.mSnackbar.handleClick(
        t("menu_menuitem_addmenuitem_please_fill_in_title"),
        "warning"
      );
    } else if (!data.description) {
      this.mSnackbar.handleClick(
        t("menu_menuitem_addmenuitem_please_input_description"),
        "warning"
      );
    } else if (!data.price) {
      this.mSnackbar.handleClick(
        t("menu_menuitem_addmenuitem_please_fill_in_price"),
        "warning"
      );
    } else if (!data.itemTime) {
      this.mSnackbar.handleClick(
        t("menu_menuitem_addmenuitem_please_fill_in_time"),
        "warning"
      );
    } else {
      this.addMenuItem();
    }
  };

  handleSubComponentChange = (name, value) => {
    let data = this.state.data;
    data[name] = value;
    this.setState({ data });
  };
  render() {
    const { classes, t, settingState, serviceSetting } = this.props;
    const { data = {} } = this.state;
    return (
      <div className={classes.contentAddForm}>
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <InputFormat
              required
              label="Code"
              name="code"
              value={
                data.code ||
                `${serviceSetting.prefixItem}${serviceSetting.totalItem + 1}`
              }
              onChange={this.handleChange}
              fullWidth={true}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <InputFormat
              required
              label={t("menu_menuitem_addmenuitem_title")}
              name="title"
              fullWidth={true}
              value={data.title}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <InputFormat
              required
              label={t("menu_menuitem_addmenuitem_price")}
              name="price"
              fullWidth={true}
              value={data.price}
              onChange={this.handleChange}
              InputProps={{
                inputComponent: NumberFormatCustom,
                endAdornment: (
                  <InputAdornment position="end">
                    {settingState.setting.currencyCode}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <InputFormat
              required
              label={t("menu_menuitem_addmenuitem_price_to_show_on_web")}
              name="priceShow"
              fullWidth={true}
              value={data.priceShow}
              onChange={this.handleChange}
              InputProps={{
                inputComponent: NumberFormatCustom,
                endAdornment: (
                  <InputAdornment position="end">
                    {settingState.setting.currencyCode}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={6}>
            <InputFormat
              select
              fullWidth={true}
              label={t("show_on_shop")}
              name="showOnShop"
              margin="normal"
              value={data.showOnShop}
              onChange={this.handleChange}
            >
              <MenuItem value={1}>{t("show")}</MenuItem>
              <MenuItem value={0}>{t("hide")}</MenuItem>
            </InputFormat>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <InputFormat
              select
              label={t("is_show_price")}
              name="isShowPrice"
              margin="normal"
              value={data.isShowPrice}
              fullWidth={true}
              onChange={this.handleChange}
            >
              <MenuItem value={1}>{t("show")}</MenuItem>
              <MenuItem value={0}>{t("hide")}</MenuItem>
            </InputFormat>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <InputFormat
              type="number"
              required
              label={t("menu_menuitem_addmenuitem_time")}
              name="itemTime"
              fullWidth={true}
              value={data.itemTime}
              onChange={this.handleChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {t("menu_menuitem_editmenuitem_minute")}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <InputFormat
              type="number"
              fullWidth={true}
              label={t("menu_menuitem_editmenuitem_position")}
              name="position"
              value={data.position || this.props.positionState + 1}
              onChange={this.handleChange}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12}>
            <SelectMenu
              onRef={(id) => (this.selectMenu = id)}
              required={true}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <DescriptionComponent
              onRef={(id) => (this.DescriptionComponent = id)}
              required={true}
              title={t("menu_menuitem_addmenuitem_description")}
              handleSubComponentChange={this.handleSubComponentChange}
              description={data.description}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <div className={classes.buttonModal}>
              <Button
                color="primary"
                variant="outlined"
                className={classes.buttonOnEdit}
                onClick={this.props.handleCancel}
              >
                {t("cancel")}
              </Button>
              <Button
                variant="contained"
                color="primary"
                className={classes.buttonOnEdit}
                onClick={this.handleSubmit}
              >
                {t("menu_menuitem_addmenuitem_add")}{" "}
              </Button>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}

AddMenuItem.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  listMenu: state.serviceMenuItem.listMenu,
  positionState: state.serviceMenuItem.position,
  settingState: state.setting,
  serviceSetting: state.serviceSetting.serviceSetting,
});

const mapDispatch = (dispatch) => ({
  serviceMenuItemDispatch: dispatch.serviceMenuItem,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(AddMenuItem)
  )
);
